/**
 * Known error messages thrown by the Salesforce Embedded Messaging SDK's async
 * internals. These escape our try/catch because they fire after `init()`
 * returns. We suppress them at the window level to prevent Sentry noise.
 */
export const SALESFORCE_SDK_ERRORS = [
  "Cannot read properties of undefined (reading 'showChatButton')",
]

export const isSalesforceSDKError = (event: ErrorEvent): boolean => {
  const message = event.message || event.error?.message || ''
  return SALESFORCE_SDK_ERRORS.some((m) => message.includes(m))
}
